<template>
	<div :style="'width:'+kuan+'px'">
		<!-- <el-upload :class="ming" :limit="100"  :headers="headers":action="url" :show-file-list="false" :on-success="Shangchuangchenggong"
		 :on-exceed="Shuliangchaochu" multiple></el-upload> -->
		<quill-editor :ref="ming" :value="value" @change="Change" :options="editorOption" @focus="onEditorFocus" class="quill-editor"></quill-editor>
		
		
		<el-dialog title="选择图片" :visible.sync="xuantu">
		  <el-form >
				<Shangtu v-model="tulie" shuliang="100" ref='tutu' ></Shangtu>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="xuantu = false">取 消</el-button>
		    <el-button type="primary" @click="Shangchuangchenggong">确 定</el-button>
		  </div>
		</el-dialog>
	</div>
</template>

<script>
	let that;
	import Shangtu from '@/zujian/Shangtu.vue'
	export default { 
		data() {
			return {
				url: '',
				headers:{},
				guangbiao:0,
				xuantu:false,
				tulie:[],
				editorOption: {
					modules: {
						toolbar: {
							container: [
								['bold', 'italic', 'underline', 'strike'], //加粗，斜体，下划线，删除线
								['blockquote', 'code-block'], //引用，代码块				 
								[{
									'list': 'ordered'
								}, {
									'list': 'bullet'
								}], //列表
								[{
									'script': 'sub'
								}, {
									'script': 'super'
								}], // 上下标
								[{
									'indent': '-1'
								}, {
									'indent': '+1'
								}], // 缩进
								[{
									'direction': 'rtl'
								}], // 文本方向	 				 
								[{
									'size': ['small', false, 'large', 'huge']
								}], // 字体大小
								[{
									'header': [1, 2, 3, 4, 5, 6, false]
								}], //几级标题	 				 
								[{
									'color': []
								}, {
									'background': []
								}], // 字体颜色，字体背景颜色
								[{
									'font': []
								}], //字体
								[{
									'align': []
								}], //对齐方式	 			 
								['clean', 'image'], //清除字体样式

							],
							handlers: {

							}
						}
					}
				}
			}
		},
		components: {
			Shangtu
		},
		props: {
			ming: {
				type: String,
				default: "ming"
			},
			value: {
				type: String,
				default: ""
			},
			kuan:{
				type: String,
				default: "750"
			}
		},
		created() {
			var that = this;
			this.editorOption.modules.toolbar.handlers = {
				image: function(e) {
					if (e) {
						that.xuantu=true;
						// document.querySelector('.' + that.ming + ' input').click();
					} else {
						this.quill.format('image', false);
					}
				}
			}
			var yonghu=this.$qu('yonghu') || [];
			this.headers.kouling=yonghu.kouling;
		},
		mounted() {
			this.url = this.$url + "?k=wenjian";
			this.quill = this.$refs[this.ming].quill;
		},
		methods: {
			Change(e) {
				this.$emit('input', e.html)
			},
			onEditorFocus(){
				this.guangbiao= this.quill.getSelection().index; // 获取光标所在位置
			},
			Shangchuangchenggong() {
				if(this.tulie && this.tulie[0] ){
					if(this.tulie  instanceof Array){
						this.tulie.forEach((e)=>{
							let length=this.guangbiao;
							this.quill.insertEmbed(length, 'image', e) // 插入图片  res.data为服务器返回的图片地址				 
							this.quill.setSelection(length + 1) // 调整光标到最后	
						})
					}else{
						let length=this.guangbiao;
						this.quill.insertEmbed(length, 'image', this.tulie) // 插入图片  res.data为服务器返回的图片地址				 
						this.quill.setSelection(length + 1) // 调整光标到最后	
					}
				}
				this.$refs.tutu.qingkong();
				this.xuantu = false;
			},
			// Shangchuangchenggong(a, b) {
			// 	if (a.shi == 1) {
			// 		let length = this.quill.getSelection().index; // 获取光标所在位置						
			// 		this.quill.insertEmbed(length, 'image', a.shu.url) // 插入图片  res.data为服务器返回的图片地址				 
			// 		this.quill.setSelection(length + 1) // 调整光标到最后			 
			// 	} else {
			// 		this.$xiaoxi(a.shu, 0);
			// 	}
			// },
			Shuliangchaochu() {
				this.$xiaoxi('超出上传数量', 0);
			}
		}
	}
</script>

<style>
.ql-snow .ql-editor img{
	display: block;
}

</style>
